import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { connect } from 'react-redux';
import './style.css';
import styles from '../../commons/styles';
import SettingsRouter from '../../routes/settingsRouter';

const { StyledWrapper, StyledWrapperLeft, StyledWrapperRight } = styles.layout;

const SettingsPage = ({
  translationCache = [],
  menuHierarchy,
  navigate,
  theme
}) => {
  const [thirdLevelMenuItems, setThirdLevelMenuItems] = useState([]);

  // Conversion of third-level menu (extracted from class method)
  const thirdLevelMenuConversion = (menu) => {
    return Object.keys(menu).map((pMenu) => {
      let children = [];
      if (menu[pMenu] && menu[pMenu].children) {
        children = thirdLevelMenuConversion(menu[pMenu].children);
      }
      return {
        key: menu[pMenu]?.key || "",
        label: menu[pMenu]?.name ? translation(menu[pMenu].name) : "",
        path: menu[pMenu]?.path || "",
        ...(children && children.length > 0 ? { children } : {})
      };
    });
  };

  // Translation utility
  const translation = (keyword) => {
    return translationCache[keyword] || keyword;
  };

  // Find object by key (recursive search)
  const findObjectByKey = (obj, key, value) => {
    if (Array.isArray(obj)) {
      for (let item of obj) {
        const result = findObjectByKey(item, key, value);
        if (result) return result;
      }
    } else if (typeof obj === 'object' && obj !== null) {
      if (obj[key] === value) return obj;
      for (const k in obj) {
        const result = findObjectByKey(obj[k], key, value);
        if (result) return result;
      }
    }
    return null;
  };

  // Effect to set third-level menu items
  useEffect(() => {
    if (menuHierarchy?.['ApplicationSettings']?.children) {
      const menu = menuHierarchy['ApplicationSettings'].children;
      const convertedMenuItems = thirdLevelMenuConversion(menu);
      setThirdLevelMenuItems(convertedMenuItems);
    }
  }, [menuHierarchy, translationCache]);

  // Menu item click handler
  const handleMenuClick = (e) => {
    const selectedObj = findObjectByKey(thirdLevelMenuItems, 'key', e.key);
    if (selectedObj) {
      navigate(selectedObj.path);
    }
  };

  const backgroundColor = theme?.components?.Menu?.itemBg || "#2f2f2f";
  return (
    <StyledWrapper style={{ minHeight: window.innerHeight - 69 }}>
      <StyledWrapperLeft backgroundColor={backgroundColor}>
        <Menu
          style={{ height: "100%" }}
          items={thirdLevelMenuItems}
          onClick={handleMenuClick}
        />
      </StyledWrapperLeft>
      <StyledWrapperRight>
        <SettingsRouter />
      </StyledWrapperRight>
    </StyledWrapper>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  menuHierarchy: state.LayoutReducer.menuHierarchy,
  theme: state.ThemeReducer,
});

export default connect(mapStateToProps)(SettingsPage);
